<template>
  <human-nav current="hcp1065">
    <template #mainContent>
      <nii-show file-name="HCP1065.2mm.nii.gz" container-id="hcpmm"></nii-show>
    </template>
  </human-nav>
</template>

<script>
import HumanNav from "@/components/public/humanNav";
import NiiShow from "@/components/xtk/niiShow";
export default {
  name: "hcpMm",
  components: {NiiShow, HumanNav}
}
</script>

<style scoped>

</style>